import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import VisibleConditionChip from './VisibleConditionChip';
import RequiredChip from './RequiredChip';
import RequiredSponsorCookieChip from './RequiredSponsorCookieChip';

const ChoiceProperties = ({ processId, choiceId }) => {
  const choice = useSelector(({ editor }) => editor.processes[processId]?.choices?.[choiceId]);
  const isShowChoiceVisibleConditionChip = !!choice.hide;
  const isShowChoiceRequiredChip = !!choice.required;
  const isShowChoiceRequiredSponsorCookieChip = !!choice.requiredSponsorCookie;

  const marginBottom = isShowChoiceVisibleConditionChip || isShowChoiceRequiredChip ? 8 : 0;

  return (
    <Container marginBottom={marginBottom}>
      {isShowChoiceVisibleConditionChip && <VisibleConditionChip processId={processId} choiceId={choiceId} />}
      {isShowChoiceRequiredChip && <RequiredChip processId={processId} choiceId={choiceId} />}
      {isShowChoiceRequiredSponsorCookieChip && <RequiredSponsorCookieChip processId={processId} choiceId={choiceId} />}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0px 8px;
  margin-bottom: ${props => props.marginBottom}px;
`;

ChoiceProperties.propTypes = {
  processId: PropTypes.number.isRequired,
  choiceId: PropTypes.number.isRequired,
};

export default ChoiceProperties;
